module.exports = __webpack_public_path__ + "img/new2.639ef0eb.png";